import { request } from './apiClient';

// Lista os tipos de ruptura válidos para um dado tipo de corpo de prova.
export const getTipoRupturaPorTipoCP = async (idTipoCorpoProva) => {
	// AJUSTE BACKEND AQUI: endpoint de catalogo para preencher FK id_tipo_ruptura.
	return await request(`/api/TipoRuptura/TipoRupturaTipoCP/${idTipoCorpoProva}`);
};

// Cria um tipo de ruptura.
export const createTipoRuptura = async (tipoRupturaData) => {
	return await request('/api/tipoRuptura', {
		method: 'POST',
		body: JSON.stringify(tipoRupturaData)
	});
};

// Atualiza um tipo de ruptura por id.
export const updateTipoRuptura = async (idTipoRuptura, tipoRupturaData) => {
	return await request(`/api/tipoRuptura/${idTipoRuptura}`, {
		method: 'PUT',
		body: JSON.stringify(tipoRupturaData)
	});
};

// Exclui um tipo de ruptura por id.
export const deleteTipoRuptura = async (idTipoRuptura) => {
	return await request(`/api/tipoRuptura/${idTipoRuptura}`, {
		method: 'DELETE'
	});
};
